import React from 'react'
import { withRouter } from 'react-router';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';

function NavBar(props) {
  return (<>
    <Navbar bg="light" data-bs-theme="light" expand="lg">
      <Container fluid>
        <Navbar.Brand href="#home">Ivo</Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse>
          <Nav activeKey={props.location.pathname} className="mr-auto">
            <Nav.Link href="/">Map</Nav.Link>
            <Nav.Link href="/statistics">Statistiken</Nav.Link>
            <Nav.Link href="/about">Info</Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  </>);
}

export default withRouter(NavBar)

